
export default {
  props: {
    text: {
      type: String,
      default: 'Lập báo cáo tài chính cá nhân',
    },
    url: {
      type: String,
      default: 'tool/report',
    },
  },
};
